import axios, { AxiosError } from 'axios';
import http from './http';

class GetSecurityQuestionService {
  static getQuestionsByEmail(email: string) {
    return http
      .get(`/auth/security-questions/${email}`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getQuestions() {
    return http
      .get('/users/security-question')
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default GetSecurityQuestionService;
